import Vue from "vue";
import * as format from "@/util/format";
import { isoUtcToLocal } from "@/util";

export type DataType = string | number | null | undefined | Date;

interface Filters {
  [key: string]: (val: DataType) => string;
}

const filters: Filters = {
  stDateTime: (sttimestamp: DataType) => {
    return format.printStDateTime(sttimestamp);
  },
  boolSiNo: (anyBool: DataType) => {
    return format.printBool(anyBool, "Sí", "No");
  },
  numDate: (numval: DataType) => {
    return format.printDate(numval, "DDMMYYYY");
  },
  date: (numval: DataType) => {
    return format.printDate(numval, "YYYY-MM-DD");
  },
  dateTime: (val: DataType) => {
    return format.printTimestamp(val);
  },
  money: (numval: DataType) => {
    return format.printMoney(numval);
  },
  cents: (numval: DataType) => {
    return format.printCents(numval);
  },
  utcToLocal: (numval: DataType) => {
    return isoUtcToLocal(numval as string, "YYYY-MM-DD HH:mm");
  }
};

for (const filterName of Object.keys(filters)) {
  Vue.filter(filterName, filters[filterName]);
}

export function applyFilter(val: DataType, filterName: string) {
  const filter = filters[filterName];
  if (filter) {
    return filter(val);
  }
  return val;
}

Vue.filter("namedFilter", applyFilter);
